import api from "axios";

export async function getAllSuggestions() {
  return api
    .get("/search/suggestions")
    .catch((error) => `getAllSuggestions ${error}`);
}

export async function autoComplete(term) {
  return api
    .get(`/search/vehicles/${term.replace(/ /g, "_")}`)
    .catch((error) => `searchAutoComplete ${error}`);
}

export async function searchByPlateAPI(term) {
  return api
    .get(`/search/plate/${term.replace(/[\s-]/g, "")}`)
    .catch((error) => `searchByPlate ${error}`);
}
